import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { OfferteService } from 'src/app/shared/dataservices/offerte.service';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { Offerte, OfferteObject } from 'src/app/shared/model/offerte';
import { ActiveContactPersoon } from 'src/app/shared/model/relatie';
import {Location} from '@angular/common';
import { utils, write, WorkBook } from 'xlsx';
import {saveAs } from 'file-saver'
import { GeneralFunctionsService } from 'src/app/shared/general-functions.service';

@Component({
  selector: 'app-offerte-edit',
  templateUrl: './offerte-edit.component.html',
  styleUrls: ['./offerte-edit.component.less']
})
export class OfferteEditComponent implements OnInit {

  offerte : Offerte = null;
  objecten: Array<OfferteObject> = null;
  @Input() offerteID : number;
  @Output() offerteAdded =  new EventEmitter<Offerte>();
  routeid = 0;
  relatieNaam ='';
  relatieNummer = 0;
  contactpersoon : ActiveContactPersoon = null;




  constructor(private relatiesService: RelatiesService,
              private objectenService: ObjectenService,
              private offerteService: OfferteService,
              private activatedRoute: ActivatedRoute,
              private location: Location,
              private functions: GeneralFunctionsService,
              private toastr: ToastrService
    ) { }

  ngOnInit(): void {
      this.routeid = Number(this.activatedRoute.snapshot.paramMap.get('id'));
      if (this.routeid) {
        this.offerteService.getOfferte(this.routeid).subscribe(data => {
          this.offerte =  data;
          this.offerteID = data.ID;
          this.loadData();
        })
      }
  }

  loadData() {
    this.offerteService.getObjecten().subscribe(data=> {
      const offertedata = data.find( e => e.ID == this.offerte.ID);
      this.relatiesService.getActiveRelatieList().subscribe(rdata=> {
          const relatiedata = rdata.find(e => e.BedrijfNummer == offertedata.BedrijfNummer);
          this.relatieNaam = relatiedata.BedrijfsNaam;
          this.relatieNummer = relatiedata.BedrijfNummer;
      })
      this.relatiesService.getActiveContactpersonenList().subscribe(cdata=> {
        const cpdata = cdata.find(e => e.ID == offertedata.Contactpersoon);
        this.contactpersoon =  cpdata;
    })

    })
    if (this.offerte.ID) {
      this.location.go("/offerte/"+ this.offerte.ID);
    } else {
      console.log(this.offerte)
    }

  }

  sanitizeNumber(event: any) :number {
    try {
      if (event) {
        let num : number = Number(event.replace(",","."));
        return num;
      }
    } catch (e) {
      console.log(e)
    }
    return 0;
  }


  ngOnChanges(changes: SimpleChanges) {
    if (!this.offerteID) return
    //if routeid is not set (No id in the URL) load the default, else we where loaden in ngOnInit
    if (this.routeid === 0) {
      this.offerteService.getOfferte(this.offerteID).subscribe(data => {
        this.offerte =  data;
        this.loadData();
      })
    } else {
      this.routeid = 0;
    }
  }


  totaalbedragInkoop() {
    return this.offerte.VerkDrukEuro + this.offerte.VerkCompleetEuro + this.offerte.VerkVoorbereidingEuro;
  }


  save() {
    if (this.offerteID == null) {
      this.offerteService.postOfferte(this.offerte).subscribe((data) => {
        if (data.error) {
            this.handleError(data.error);
            return;
        }
        this.offerteID = data.id;
        this.offerte.ID = data.id;
        this.toastr.info("", "Opgeslagen");
        this.offerteAdded.emit(this.offerte);
      } )
    } else {
      console.log(this.offerte)
      this.offerteService.saveOfferte(this.offerteID,this.offerte).subscribe(() => {
        this.toastr.info("", "Opgeslagen");
      } )

    }
  }
  add() {
    if (this.objecten == null) {
      this.offerteService.getObjecten().subscribe(data => {
        this.objecten =  data;
      })
    }
    this.offerteID = null;
    this.offerte = new Offerte();
    this.offerte.ID = 0;

  }

  handleError(data: any) {
    try {
      this.toastr.error("", data.originalError.info.message, {timeOut: 0});
    }catch(e) {

    }
  }

  delete() {

  }

  excel() {
    this.offerteService.postRapport(this.offerte.ID).subscribe(result => {
      try {
        console.log(result);
        const ws_name = 'offerte';
        const wb: WorkBook = { SheetNames: [], Sheets: {} };
        const ws: any = utils.json_to_sheet(result);
        wb.SheetNames.push(ws_name);
        wb.Sheets[ws_name] = ws;
        const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type:'binary' });
        console.log(wbout);
        saveAs(new Blob([this.functions.s2ab(wbout)],{type:"application/octet-stream"}), 'offerte.xlsx');
      } catch (E) {
        console.log(E);
      }
    })
  }

  word() {
    this.toastr.info("Word document wordt gegenereerd, dit kan even duren!")
    this.offerteService.getWordRApport(this.offerte.ID).subscribe(result => {
        window.open(result.url,"_blank");
    });
  }

}
